import React from 'react';

const Inventory = () => {
    return (
        <div>
            <h2>This Is Inventory</h2>
        </div>
    );
};

export default Inventory;